
import { Component } from '@angular/core';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {ProductService} from "./services/product.service";
import {Product} from "./model/Product";
import {Type} from "./model/Type";
import {TypeAndProductsToDisplay} from "./model/TypeAndProductsToDisplay";
import {Router} from '@angular/router';
import {Photo} from "./model/Photo";
import {PhotoService} from "./services/photo.service";
import {ModalComponent} from "./components/modal-component";
import {TypeService} from "./services/type.service";
import {State} from "./model/State";
import {Order} from "./model/Order";
import {PhonePipe} from "./components/phone-pipe.component";
import {StateService} from "./services/state.service";
import {ToastyConfig, ToastyService} from "ng2-toasty";
import { Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import {forEach} from "@angular/router/src/utils/collection";

@Component({
    selector: 'app-admin-manage-orders',
    templateUrl: './manage-orders.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [OrderService],
})

export class ManageOrdersComponent implements OnInit {
    ngOnInit(): void {
        this.getListOrders(null, new State(1));
        this.getStateList();
    }
    title = 'My Order App';

    constructor(private orderService : OrderService,
                private stateService: StateService,
                private toastyService:ToastyService,
                private toastyConfig: ToastyConfig,
                private router: Router,
                public modal: Modal) {
        this.toastyConfig.theme = 'bootstrap'
    }
    order:Order = null;
    nbMenu: number = 0;
    nbProduct: number[] = [];
    productByType: Product[][] = [];
    listOrders: Order[];
    listStates: State[];

    getListOrders(emailClient: string, state: State): void {
        this.orderService.getListOrderByState(emailClient, state).then((listOrders) => {
            this.listOrders = listOrders
        }, (error) => {
            console.error(error);
        })
    }

    getStateList(): void {
        this.stateService.getListStates().then((listStates) => {
            this.listStates = listStates;
        }, (error) => {
            console.error(error);
        })
    }

    changeState(order: Order, state: State) {
        this.orderService.patchOrderState(order,state).then((result) => {
            this._addToast("success", "Nouvel état commande " + order.id + ": " + state.name);
            order.state = state;
        }, (error) => {
            console.error(error);
            this._addToast("error", "Erreur lors du changement d'état");
        })
    }

    private _addToast(type: string, message: string) {
        // Just add default Toast with title only
        if(type === "error") {
            this.toastyService.error(message);
        } else {
            this.toastyService.default(message);
        }
    }

    openModalClick(order: Order) {
        /*const dialogRef = this.modal.alert()
            .size('lg')
            .showClose(true)
            .title('Détail de la commande ' + order.id)
            .body(`
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div>Le client</div>
                        <div><span>Nom : </span>` + order.client.firstName + ` ` + order.client.lastName + `</div>
                        <div><span>Téléphone : </span>{{order.client.tel}}` + order.client.tel + `</div>
                        <div><span>Email : </span>` + order.client.email + `</div>
                        <div><span>Entreprise : </span>` + order.client.address.name + `</div>
                        <div><span>Adresse de livraison : </span>` + order.client.address.formattedAddress + `</div>
                        <div><span>Détails : </span>` + order.client.address.details + `</div>
                    </div>
                    <div class="col">
                        <div>La commande</div>
                    </div>
                </div>
            </div>`)
            .open();

        /*dialogRef
            .then( dialogRef => {
                dialogRef.result.then( result => alert(`The result is: ${result}`);
            });*/

        this.order = order;
        for(let billElement of order.billElementsList) {
            if(billElement.menuOrderedList) {
                for(let menuOrdered of billElement.menuOrderedList) {
                    this.nbMenu = this.nbMenu + menuOrdered.number;
                    for(let product of menuOrdered.productList) {
                        if(!this.nbProduct.includes(product.id)) {
                            this.nbProduct[product.id] = 0;
                            if(!this.productByType[product.type.id]) this.productByType[product.type.id] = [];
                            this.productByType[product.type.id].push(product);
                        }
                        this.nbProduct[product.id] += 1;
                    }
                }
            }

            if(billElement.productAndNumberList) {
                for(let productAndNumber of billElement.productAndNumberList) {
                    if(!this.nbProduct.includes(productAndNumber.product.id)) {
                        this.nbProduct[productAndNumber.product.id] = 0;
                        if(!this.productByType[productAndNumber.product.type.id]) this.productByType[productAndNumber.product.type.id] = [];
                        this.productByType[productAndNumber.product.type.id].push(productAndNumber.product);
                    }
                    this.nbProduct[productAndNumber.product.id] += productAndNumber.number;
                }
            }

        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/manage-orders.component.ts